import React from 'react';
import '../styles/index.css';
import '../styles/guide.css';
import Menu from '../components/Menu.js';
import TextBlock from '../components/TextBlock.js';

export default function Guide() {
	let timeline = require('../txt/TimelineTxt.json');
	let shootDay = require('../txt/ShootDayTxt.json');
	var num = 3;

	return(
		<div className="container text">
			<div className="header">
				<Menu />
			</div>
			<div className="item">
				<h1>SHOOT GUIDE</h1>
				<p>Welcome! Thank you for entrusting me with a wonderful and intimate moment in your relationship! I can't wait to meet you and make some great memories. Here's a detailed guide from brainstorming themes to technical questions you may have. I also love getting to know your love story personally over a Zoom call or treating you to coffee! If you've got questions or just want to chat, don't hesitate to hit me up.</p>
				<p>This guide is designed to help you make the most of my photography and assist with a few aspects of the planning process. Where and when you need, adjustments can be available and I would love to accommodate you in any way you need. I will communicate to you what to expect from me as your photographer.</p>
				<br />
				<div id="timeline">
					{timeline.map((elt) => {
						num += 1;
						return (<div className={'text-container'}>
							<TextBlock
								subtitle={elt.subtitle}
								mainText={elt.mainText}
							/>
							<br />
						</div>);
					})}
				</div>
				<div id="shoot_day">
					{shootDay.map((elt) => {
						num -= 1;
						return (<div className>
							<div className={'text-container'}>
								<div className="guide-flower">
									<img 
										alt={'bitmap flower'}
										src={require('/public/flowers/' + num + '.png')}
										className={'guide-flower'}
									/>
								</div>
								<TextBlock
									subtitle={elt.subtitle}
									mainText={elt.mainText}
								/>
							</div>
							<br />
						</div>);
					})}
				</div>
				<p>Every single couple is extremely personal to me, and with every wedding, shoot, or project, I feel like falling in love all over again. Thank you for exercising one of the most imperative values in life - and all the more, for choosing me capture it.</p>
				<p>I'm excited!</p>
				<p>If there are any questions in the guide, please don't hesitate to <a href={`/contact`}>reach out!</a></p>
				<br />
				<br />
				<br />
			</div>
		</div>
	);
}